import React from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';

const columns = [
    'Product Name',
    'English',
    'Danish',
    'Finnish',
    'Icelandic',
    'Norwegian',
    'Swedish',
    'Spanish',
    'Portuguese',
    'Status',
];

const example = [
    'Milk',
    'Milk',
    'Mælk',
    'Maito',
    'Mjólk',
    'Melk',
    'Mjölk',
    'Leche',
    'Leite',
    'Confirmed',
];

function FileUploadInstructions() {
    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 3 }}>
            <Typography variant="h6" fontWeight={700}>
                Excel upload format
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 1.5 }}>
                Use these exact column names. Language cells may be left empty when a translation is unavailable.
            </Typography>

            <TableContainer>
                <Table size="small" sx={{ minWidth: 900 }}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column} sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                                    {column}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {example.map((value, index) => (
                                <TableCell key={`${columns[index]}-${value}`}>{value}</TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}

export default FileUploadInstructions;
